module.exports = __webpack_public_path__ + "static/media/beach.a9bc8bc9.jpg";